export class CarrierRegisterModel {

    constructor() {
        this.id = 0;
        this.company = '';
        this.contactPerson = '';
        this.email = '';
        this.street = '';
        this.city = '';
        this.country = '';
        this.chamberOfCommerce = '';
        this.zipCode = '';
        this.faxNumber = '';
        this.website = '';
        this.vatNumber = '';
        this.mobilePhoneNumber = '';
        this.phoneNumber = '';
        this.username = '';
    }

    public id: number;
    public company: string;
    public contactPerson: string;
    public email: string;
    public street: string;
    public city: string;
    public country: string;
    public zipCode: string;
    public phoneNumber: string;
    public mobilePhoneNumber: string;
    public faxNumber: string;
    public website: string;
    public vatNumber: string;
    public chamberOfCommerce: string;
    public username: string;
}
